import React, { forwardRef } from 'react';
import {
  removeNonDigitsFromString,
  removeNonDigitsAndLettersFromString
} from '../../utils/basic';
import { NumberFormatBase } from 'react-number-format';

// CPF é sempre numérico; CNPJ alfanumérico (vigência jul/2026) aceita letras
// maiúsculas A-Z nas 12 primeiras posições (os 2 DV finais continuam numéricos,
// o que a validação garante). A máscara visual não muda: XX.XXX.XXX/XXXX-XX.
//
// O NumberFormatBase, por padrão, só aceita dígitos: extrai o valor com
// removeFormatting numérico e bloqueia a navegação de caret com
// isValidInputCharacter = charIsNumber. Para CNPJ precisamos liberar letras
// tanto na extração do valor quanto no caret, sem trocar de componente.
const CpfCnpjTextField = forwardRef(
  ({ onChange, type = 'both', ...other }, ref) => {
    const isCnpjCapable = type === 'cnpj' || type === 'both';

    const strip = (value) =>
      isCnpjCapable
        ? removeNonDigitsAndLettersFromString(value ?? '').toUpperCase()
        : removeNonDigitsFromString(value ?? '');

    const isValidInputCharacter = (char) =>
      isCnpjCapable ? /[A-Za-z0-9]/.test(char) : /\d/.test(char);

    const formatCpfCnpj = (value) => {
      const stripped = strip(value);
      const size = stripped ? stripped.length : 0;

      if ((size > 11 && type === 'both') || type === 'cnpj') {
        let finalValue = stripped.slice(0, 2);
        if (stripped.length > 2) {
          finalValue += '.' + stripped.slice(2, 5);
        }
        if (stripped.length > 5) {
          finalValue += '.' + stripped.slice(5, 8);
        }
        if (stripped.length > 8) {
          finalValue += '/' + stripped.slice(8, 12);
        }
        if (stripped.length > 12) {
          finalValue += '-' + stripped.slice(12, 14);
        }
        return finalValue;
      } else {
        let finalValue = stripped.slice(0, 3);
        if (stripped.length > 3) {
          finalValue += '.' + stripped.slice(3, 6);
        }
        if (stripped.length > 6) {
          finalValue += '.' + stripped.slice(6, 9);
        }
        if (stripped.length > 9 && type === 'cpf') {
          finalValue += '-' + stripped.slice(9, 11);
        }
        if (stripped.length > 9 && type === 'both') {
          finalValue += '-' + stripped.slice(9);
        }
        return finalValue;
      }
    };

    return (
      <NumberFormatBase
        {...other}
        getInputRef={ref}
        onValueChange={(values) => {
          onChange(values.formattedValue);
        }}
        removeFormatting={(val) => strip(val)}
        isValidInputCharacter={isValidInputCharacter}
        format={formatCpfCnpj}
      />
    );
  }
);

export default CpfCnpjTextField;
